import * as React from "react";
import { connect } from "react-redux";
import { FormComponentProps } from "antd/lib/form";
import { ApplicationState } from "src/store";
import { Form, Select, Row, Col, Button, DatePicker, Input } from 'antd';
import { StatusType } from "src/store/pay/types";
import Tools from "src/utils/tools";
import "./MsSearchPay.scss";

interface PropsFromState {
  statusList: StatusType[];
}

interface PropsOwn extends FormComponentProps {
  searchValue: any;
  onRef: any;
  clickSearch: (obj: object) => void;
}

const mapStateToProps = ({ payState }: ApplicationState) => ({
  statusList: payState.statusList
});

type AllProps = PropsFromState & PropsOwn;

const FormItem = Form.Item;

class MsSearchPay extends React.Component<AllProps> {

  public componentDidMount() {
    this.props.onRef(this.props.form);
    if (this.props.searchValue) {
      this.props.form.setFieldsValue(this.props.searchValue);
    }
  }

  /**
   * 点击查询
   * 校验通过后把数据提交到上层组件
   */
  public onHandleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: any) => {
      let startTime = "";
      let endTime = "";
      let param = { ...values, batchNo: values.batchNo.trim() };
      if (param.DateRange.length) {
        startTime = Tools.formatTime(new Date(param.DateRange[0]).getTime(), false);
        endTime = Tools.formatTime(new Date(param.DateRange[1]).getTime(), false);
      } 
      delete param.DateRange;
      param = {
        ...param,
        startTime,
        endTime
      }
      this.props.clickSearch(param);
    });
  }
  /**
   * 重置数据
   */
  public onHandleReset = () => {
    this.props.form.resetFields();
  }

  public render() {
    const { getFieldDecorator } = this.props.form;
    const statusList = this.props.statusList.map(one => (
      <Select.Option key={`${one.code}`} value={one.code}>{one.statusDesc}</Select.Option>
    ));
    return (
      <Form className="ms-search-form" onSubmit={ this.onHandleSubmit }>
        <Row gutter={16}>
          <Col className="col-item range">
            <FormItem label="创建时间" colon={false}>
              {getFieldDecorator('DateRange', {
                initialValue: [],
              })(
                <DatePicker.RangePicker />
              )}
            </FormItem>
          </Col>
          <Col className="col-item status">
            <FormItem label="状态" colon={false}>
              {getFieldDecorator("status", {
                initialValue: ""
              })(
                <Select>
                  <Select.Option key="" value="">全部</Select.Option>
                  {statusList}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col className="col-item batch-no">
            <FormItem label="发放编号" colon={false}>
              {getFieldDecorator("batchNo", {
                initialValue: ""
              })(
                <Input placeholder="请输入发放编号" autoComplete="off" maxLength={30} />
              )}
            </FormItem>
          </Col>
          <Col style={{ textAlign: "right" }}>
            <FormItem>
              <Button type="primary" className="btn" htmlType="submit">查询</Button>
              <Button type="default" onClick={ this.onHandleReset }>清空</Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default connect(mapStateToProps)(Form.create()(MsSearchPay));



// WEBPACK FOOTER //
// ./src/components/ms-pay/ms-search-pay/MsSearchPay.tsx